export default {
  subscribe: (next: (e: UIEvent) => void) => {
    const cb = next.bind(this);
    window.addEventListener('resize', cb);
    return { unsubscribe: () => window.removeEventListener('resize', cb) };
  },
};
